// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".13956753af87d58baab9c2808f87e3f060207698.chunk.bundle.js";
};